<script setup>
defineProps({
  urls: { type: Array, default: () => [] }
})
</script>

<template>
  <div v-if="urls.length" class="flex gap-1.5 flex-wrap">
    <a
      v-for="(url, idx) in urls"
      :key="url"
      :href="url"
      target="_blank"
      rel="noopener"
      class="w-12 h-12 rounded-[var(--radius-input)] overflow-hidden border border-[color:var(--line)] block"
      :title="`Photo ${idx + 1}`"
    >
      <img :src="url" alt="" class="w-full h-full object-cover" />
    </a>
  </div>
</template>
